import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const Login             = () => import(/* webpackChunkName: "Login" */      '@/components/View/Layout/Login')
const Index             = () => import(/* webpackChunkName: "Index" */      '@/components/View/Layout/Index')
const Dashboard         = () => import(/* webpackChunkName: "Dashboard" */  '@/components/View/Layout/Dashboard')

const AdminUser         = () => import(/* webpackChunkName: "AdminUser" */  '@/components/View/Admin/AdminUser')
const AdminRole         = () => import(/* webpackChunkName: "AdminRole" */  '@/components/View/Admin/AdminRole')
const AdminUpdate         = () => import(/* webpackChunkName:"AdminAdminUpdate" */  '@/components/View/Admin/Update')
const Game              = () => import(/* webpackChunkName: "Game" */       '@/components/View/Game/Game')
const Agent             = () => import(/* webpackChunkName: "Agent" */      '@/components/View/Agent/Agent')
const Player            = () => import(/* webpackChunkName: "Player" */     '@/components/View/Player/Player')
const PlayerLog         = () => import(/* webpackChunkName: "PlayerLog" */  '@/components/View/Player/LoginLog')
const Role              = () => import(/* webpackChunkName: "Role" */       '@/components/View/Player/Role')
const Order             = () => import(/* webpackChunkName: "Order" */      '@/components/View/Player/Order')
const CoinsLog          = () => import(/* webpackChunkName: "CoinsLog" */   '@/components/View/Player/CoinsLog')
const TokenBind          = () => import(/* webpackChunkName: "TokenBind" */   '@/components/View/Player/TokenBind')

const Server            = () => import(/* webpackChunkName: "Server" */     '@/components/View/Server/Server')

//封禁
const Forbid            = () => import(/* webpackChunkName: "Forbid" */     '@/components/View/Forbid/Forbid')

//反馈
const Feedback          = () => import(/* webpackChunkName: "Feedback" */   '@/components/View/Feedback/Feedback')

//error
const NotAllowed        = () => import(/* webpackChunkName: "NotAllowed" */ '@/components/View/Errors/403')
const NotFound          = () => import(/* webpackChunkName: "NotFound" */   '@/components/View/Errors/404')
const ServerError       = () => import(/* webpackChunkName: "ServerError" */'@/components/View/Errors/500')

//V1
const V1Player          = () => import(/* webpackChunkName: "V1Player" */    '@/components/View/V1Player/Player')
const V1PlayerRole      = () => import(/* webpackChunkName: "V1PlayerRole" */'@/components/View/V1Player/Role')
const V1PlayerOrder     = () => import(/* webpackChunkName: "V1PlayerOrder" */'@/components/View/V1Player/Order')
const V1PlayerPay       = () => import(/* webpackChunkName: "V1PlayerPay" */ '@/components/View/V1Player/Pay')
const V1PlayerOrderS    = () => import(/* webpackChunkName: "V1PlayerOrderS" */'@/components/View/V1Player/OrderStatistics')
const V1PRolePay        = () => import(/* webpackChunkName: "V1PRolePay" */ '@/components/View/V1Player/RolePay')
//实名测试
const LoginTest         = () => import(/* webpackChunkName: "LoginTest" */  '@/components/View/PayData/LoginTest')
const OldPayTest        = () => import(/* webpackChunkName: "OldPayTest" */ '@/components/View/PayData/OldPayTest')
const Switch            = () => import(/* webpackChunkName: "OldPayTest" */ '@/components/View/PayData/Switch')
Vue.use(Router)

export default new Router({
    //mode: 'history',
    routes: [
        { path: '/admin/login', component: Login },
        {
            path: '/',
            name: 'Index',
            component: Index,
            children:[
                { path: '/',                     component: Dashboard },
                //管理员列表
                { path: '/admin/user',           component: AdminUser },
                //管理员角色列表
                { path: '/admin/role',           component: AdminRole },
                { path: '/admin/update',         component: AdminUpdate },
                //游戏管理
                { path: '/admin/game',           component: Game },
                //游戏管理
                { path: '/admin/server',         component: Server },
                //渠道管理
                { path: '/admin/agent',          component: Agent },
                //玩家管理
                { path: '/admin/player',         component: Player },
                { path: '/admin/player/log',     component: PlayerLog },
                { path: '/admin/player/coins/log',     component: CoinsLog },
                { path: '/admin/player/token/bind',     component: TokenBind },
                //玩家角色
                { path: '/admin/player/role',    component: Role },
                //玩家订单
                { path: '/admin/player/order',   component: Order },
                //玩家订单
                { path: '/admin/feedback',       component: Feedback },
                //封禁管理
                { path: '/admin/forbid',         component: Forbid },
                //V1玩家管理
                { path: '/admin/v1/player',      component: V1Player },
                { path: '/admin/v1/player/role', component: V1PlayerRole },
                { path: '/admin/v1/player/role/pay', component: V1PRolePay },
                { path: '/admin/v1/player/order',component: V1PlayerOrder },
                { path: '/admin/v1/player/order/statistic',component: V1PlayerOrderS },
                { path: '/admin/pay',            component: V1PlayerPay },
                { path: '/admin/pay/login',      component: LoginTest },
                { path: '/admin/pay/old',        component: OldPayTest },
                { path: '/admin/pay/switch',     component: Switch },
            ]
        },
        //
        { path: '/403', component: NotAllowed },
        { path: '/404', component: NotFound },
        { path: '/500', component: ServerError },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js